import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=01b0f71a"
import script from "./Portal.ts?vue&type=script&lang=ts"
export * from "./Portal.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports